import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import PageList from '@/components/facebook/PageList.vue';
import ConfirmationDialog from '@/components/ConfirmationDialog.vue';
import ActionButton from '@/components/action_button/Index.vue';
import PageUnsubscribe from '@/plugins/graphql/mutations/page-unsubscribe.gql';
import appBasic from '@/plugins/graphql/queries/v2/app-basic.gql';
import GraphqlErrorMixin from '@/helpers/vue_mixins/GraphqlErrorMixin';
import { Mutation } from 'vuex-class';
import { successfulDestroy } from '@/helpers/mixins/LocalizationHelper';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import CleverTapEventsMixin from '@/helpers/vue_mixins/v3/CleverTapEventsMixin';
import Modal from '@/components/v3/Modal.vue';
let SettingsPageSubscription = class SettingsPageSubscription extends Mixins(GraphqlErrorMixin, RouterParamsAppMixin, ViewportSizeMixin, CleverTapEventsMixin, Modal) {
    constructor() {
        super(...arguments);
        this.modalOpen = false;
    }
    appBasicQuery() {
        return {
            query: appBasic,
            variables: {
                appUuid: this.appUUID,
            },
        };
    }
    get generateTitle() {
        return this.$route.meta.childTitle;
    }
    async unconnect() {
        let success = true;
        await this.pageUnsubscribe()
            .then(() => {
            const delay = 3000;
            setTimeout(() => {
                this.$store.commit('setAppActivePage', {});
            }, delay);
            const msg = successfulDestroy('Page');
            this.successNotification(msg);
            this.clearPersistentErrorNotification();
            this.onAppDisconnect('messenger');
        })
            .catch((error) => {
            success = false;
            this.errorNotification(error.message);
            this.logError(error.message);
        })
            .finally(() => {
            this.hideConfirmationDialog();
            if (success) {
                const delay = 3000;
                setTimeout(() => {
                    this.modalOpen = true;
                }, delay);
            }
            this.$refs.pageList.refetchFbPages();
        });
    }
    pageUnsubscribe() {
        const vm = this;
        const { appUUID } = this;
        return this.$apollo.mutate({
            mutation: PageUnsubscribe,
            variables: {
                input: {
                    appUuid: appUUID,
                },
            },
            // To Update Persistent Mini App Status to Reconnect
            refetchQueries: [vm.appBasicQuery()],
        });
    }
};
__decorate([
    Mutation('hideConfirmationDialog')
], SettingsPageSubscription.prototype, "hideConfirmationDialog", void 0);
SettingsPageSubscription = __decorate([
    Component({
        apollo: {
            app: {
                query: appBasic,
                variables() {
                    return {
                        appUuid: this.appUUID,
                    };
                },
                update(data) {
                    return data.app;
                },
            },
        },
        components: {
            PageList,
            ConfirmationDialog,
            ActionButton,
        },
    })
], SettingsPageSubscription);
export default SettingsPageSubscription;
